const defaultGuid = "00000000-0000-0000-0000-000000000000";
export {
  defaultGuid
};
//# sourceMappingURL=guid.constants.js.map
